<template>
  <div>
    <template v-if="!loading">

      <b-row align-v="center">
        <b-col lg="3">
          <h6 class="h6-semibold-azure-uppercase">Scegli di risparmiare</h6>
          <h2 class="h2-bold-black">Seleziona il tuo comune</h2>
          <p class="p-medium-gray-600 mb-5">Scopri i vantaggi di passare a SGR Luce e Gas. Personalizza con noi la tua energia!</p>
        </b-col>
        <b-col lg="6" class="lg:px-6">
          <label class="d-block">Inserisci il tuo comune</label>
          <vue-bootstrap-typeahead
              class="b-autocomplete"
              :data="comuni"
              v-model="search"
              size="lg"
              :serializer="s => s.value"
              placeholder="Es: Rimini"
              @hit="comune = $event.value"
          ></vue-bootstrap-typeahead>

          <div class="lg:text-right">
          <button @click="checkComune(comune)"
                  :disabled="comune == null || comune.length < 2"
            class="button-azure-rounded mt-2 px-8">Avanti</button>
          </div>
        </b-col>

        <b-col lg="3" class="text-center lg:text-right d-none d-md-block">
          <div class="icon mb-8 mt-5 lg:mt-0 px-4 lg:px-0">
            <img src="img/city.svg">
          </div>
        </b-col>
      </b-row>

    </template>
  </div>
</template>

<script>
import VueBootstrapTypeahead from 'vue-bootstrap-typeahead'
const API_URL = 'wp-admin/admin-ajax.php?action=automplete_comune&query=:query'
export default {
  name: 'StepComune',
  components: {VueBootstrapTypeahead},
  data() {
    return {
      thisStep: 0,
      localOptions: null,
      loading: false,
      webPath: process.env.VUE_APP_WEB_PATH,
      search: '',
      comuni: [],
      comune: null,
    }
  },
  watch: {
    search: function (val){
      this.getAddresses(val)
    }
  },
  props: {
    steps: {
      type: Number,
      required: true,
    },
    current: {
      type: Number,
      default: 0,
    },
    options: {
      type: [Array, Object],
      required: true
    }
  },
  created() {
    this.$emit('setCurrent', this.thisStep)
    this.localOptions = {...this.options};
    if(typeof this.localOptions.comune !== 'undefined' && this.localOptions.comune != null)
      this.checkComune(this.localOptions.comune);

    this.trackFbViewContent('configuratore', 'step-comune');
  },
  methods: {
    checkComune(comune) {
      var values = comune.split('(');
      comune = values[0].trim();

      if(comune == null || comune.length < 2) return false;
      let that = this;
      that.loading = true;
      that.axios.get(that.webPath + 'wp-admin/admin-ajax.php', {
        params: {
          action: 'check-comune',
          query: comune,
        }
      })
          .then(response => {
            if (!response.data.success) {
              window.location.replace(response.data.redirecUrl);
            } else {
              sessionStorage.setItem('provincia', values[1].replace(')', '').trim());
              sessionStorage.setItem('comune', values[0]);
              that.$router.push({name: 'step-1', query: {comune:comune} })
              that.loading = false;
            }
          })
          .catch(error => {
            console.log('error', error);
          })

    },

    async getAddresses(query) {
      let url = this.webPath + API_URL;
      let res = await fetch(url.replace(':query', query))
      let suggestions = await res.json()
      this.comuni = suggestions.suggestions;
    }
  },
}
</script>

<style scoped lang="scss">
.h2-bold-black{
  font-size: 36px;
  line-height: 40px;
  font-weight: 600;
}
.icon{
  i{
    font-size: 200px;
  }
}
</style>
<style lang="scss">
.vbt-autcomplete-list{
  padding: 0 !important;
  border: 1px solid #ecf1f4;
  background: #FFF;
  overflow: auto;
  border-radius: 8px;
  margin-top: 8px;
  -webkit-box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);

  &:empty{
    border: none !important;
    display: none;
  }

  .list-group-item{
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin: 0;
    border: 0;
    span{
      color: #585F6C;
      font-size: 14px;
      line-height: 18px;
      vertical-align: middle;
      strong{
        font-size: 18px;
        color: #0090df;
      }
    }
    &.active{
      background: #ecf1f4;
      margin: 0;
      border: 0;
      span{
        color: #585F6C;
        strong{
          color: #0090df;
        }
      }
    }
  }
}
.b-autocomplete{
  .form-control{
    font-size: 18px;
    line-height: 1.4;
    border: none;
    border-radius: 28px;
    height: 48px !important;
    background-color: #ecf1f4;
    text-align: center;
    color: #191c21 !important;
    padding: 16px 32px;
    text-align: left;
  }
}
</style>